import { devhubMakeStyles, DevHubTypography } from '@devxdiscover/devhub-ui';

/**
 * GreenScoreProfileMetric are the cards used to explain the Green Energy calculation
 * @param props Green Energy Profile values to paint metric cards
 */
function GreenScoreProfileMetric(props: GreenScoreProfileMetricProps) {
  const {
    metricName,
    calculatedPointValue,
    unitQuantity,
    unitMultiplier,
    unitDescription,
  } = props;

  const classes = devhubMakeStyles({
    cardContainer: {
      border: '1px solid #3ea436',
    },
    headerStripe: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '40px',
      backgroundColor: '#3ea436',
      color: 'white',
    },
    scoreStripe: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '60px',
      backgroundColor: 'lightgrey',
      color: '#3ea436',
    },
    calculationContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      borderBottom: '1px solid grey',
      height: '85px',
    },
    descriptionContainer: {
      height: '50px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: '10px',
      textAlign: 'center',
    },
    leftExpression: {
      color: '#3ea436',
    },
    rightExpression: {
      color: '#3ea436',
    },
    leftExpressionContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    rightExpressionContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    operator: {
      fontSize: '2rem',
    },
  })();

  return (
    <div className={classes.cardContainer}>
      <div className={classes.headerStripe}>
        <DevHubTypography fontSize="large">{metricName}</DevHubTypography>
      </div>
      <div className={classes.scoreStripe}>
        <DevHubTypography fontSize="extraLarge">{`${calculatedPointValue} Points`}</DevHubTypography>
      </div>
      <div className={classes.calculationContainer}>
        <div className={classes.leftExpressionContainer}>
          <div className={classes.leftExpression}>
            <DevHubTypography fontSize="extraLarge" weight="bold">
              {unitQuantity}
            </DevHubTypography>
          </div>
          <div className={classes.leftExpressionLabel}>
            <DevHubTypography fontSize="large" fontColor="medGray">
              Units
            </DevHubTypography>
          </div>
        </div>
        <DevHubTypography
          fontSize="extraLarge"
          fontColor="medGray"
          weight="bold"
          className={classes.operator}
        >
          x
        </DevHubTypography>
        <div className={classes.rightExpressionContainer}>
          <div className={classes.rightExpression}>
            <DevHubTypography fontSize="extraLarge" weight="bold">
              {unitMultiplier}
            </DevHubTypography>
          </div>
          <div className={classes.rightExpressionLabel}>
            <DevHubTypography fontSize="large" fontColor="medGray">
              Multiplier
            </DevHubTypography>
          </div>
        </div>
      </div>
      <div className={classes.descriptionContainer}>
        <DevHubTypography fontSize="medium" fontColor="medGray">
          {unitDescription}
        </DevHubTypography>
      </div>
    </div>
  );
}

export default GreenScoreProfileMetric;
